module.exports = __webpack_public_path__ + "1_0_57/img/android-button.a0560e00.png";